import { BookingSlot } from '../models/booking-slot';

export class BookingSlotGeneratorParams {
  constructor(
    public maxCapacity: number,
    public slotLenght: number,
    public slotInterval: number,
    public singleUse: boolean,
  ) { }
}

export class BookingInMemoryBookingSlotGenerator {
  private _generatedSlots = new Map<string, BookingSlot[]>();
  private _lastSlotId = 1;
  private _params = new BookingSlotGeneratorParams(100, 0.5, 0, false);

  constructor(
    initialParams?: BookingSlotGeneratorParams,
  ) {
    if (initialParams) {
      this._params = initialParams;
    }
  }

  static generateSlotIntervals(from: number, to: number, lenght: number = 0.5, interval: number = 0): Array<[number, number]> {
    const result = new Array<[number, number]>();

    for (let start = from, end = start + lenght; start < to; start += lenght, end += lenght) {
      result.push([start, end]);
      start += interval;
      end += interval;
    }

    return result;
  }

  private _getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getOrGenerateSlots(
    areaId: number,
    from: number,
    to: number,
    bookingDate: Date,
    params?: BookingSlotGeneratorParams,
  ) {
    const key = this._getSlotKey(bookingDate, areaId);

    if (!this._generatedSlots.has(key)) {
      this._generatedSlots.set(key, this._generate(
        areaId,
        from,
        to,
        bookingDate,
        params ? params : this._params,
      ));
    }

    return this._generatedSlots.get(key);
  }

  private _getSlotKey(date: Date, areaId: number): string {
    return date.toDateString() + ', ' + areaId;
  }

  private _generate(
    areaId: number,
    from: number,
    to: number,
    bookingDate: Date,
    params: BookingSlotGeneratorParams,
  ): BookingSlot[] {
    return BookingInMemoryBookingSlotGenerator.generateSlotIntervals(from, to, params.slotLenght, params.slotInterval).map(
      (interval, index) => {
        const slot = new BookingSlot(
          this._lastSlotId,
          areaId,
          bookingDate,
          interval[0],
          interval[1],
          params.maxCapacity,
          params.singleUse ? 0 : this._getRandomInt(0, params.maxCapacity),
        );

        this._lastSlotId++;
        return slot;
      });
  }

}
